import SSOSuccess from "./SSOSuccess";

export default SSOSuccess;
